import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import Login from '../pages/auth/Login.tsx';
import BillingsStore from '../pages/dashboard/billings/billings-store';
import CustomersStore from '../pages/dashboard/customers/customers-store';
import DashboardStore from '../pages/dashboard/dashboard/dashboard-store';
import history from '../utils/history';
import { AuthGuard, DashGuard } from './modules.js';
import AuthVerifyComponent from '../utils/check';
import CustomerController from '../pages/dashboard/customers';
import DashboardController from '../pages/dashboard/dashboard';
import MeterController from '../pages/dashboard/meters';
import RatesController from '../pages/dashboard/rates';
import PaymentsController from '../pages/dashboard/payments';
import SettingsController from '../pages/dashboard/settings';
import RolesController from '../pages/dashboard/users-role/roles';
import UsersController from '../pages/dashboard/users-role/users';
import BillingsController from '../pages/dashboard/billings';
import PaymentsViewController from '../pages/dashboard/payments-view';
import AdditionalFeesController from '../pages/dashboard/additional-fees';
import auth from '../lib/services';
import Logout from '../pages/dashboard/logout';
import SubscriberController from '../pages/dashboard/subscriber';

export default function App() {
  const role = auth.getRole();
  return (
    <Router history={history}>
      <Switch>
        <AuthGuard exact path="/" component={Login} />
        {role?.dashboard && (
          <DashGuard exact path="/dashboard" component={DashboardController} />
        )}
        {role?.customers && (
          <DashGuard exact path="/customers" component={CustomerController} />
        )}
        {role?.billings && (
          <DashGuard exact path="/billings" component={BillingsController} />
        )}
        {role?.meters && (
          <DashGuard exact path="/meters/:id?" component={MeterController} />
        )}
        {role?.rates && (
          <DashGuard exact path="/rates" component={RatesController} />
        )}
        <DashGuard
          exact
          path="/create-payments"
          component={PaymentsController}
        />
        {role?.settings && (
          <DashGuard exact path="/settings" component={SettingsController} />
        )}
        <DashGuard exact path="/users-role/roles" component={RolesController} />
        <DashGuard exact path="/users-role/users" component={UsersController} />
        {role?.payments && (
          <DashGuard
            exact
            path="/payments"
            component={PaymentsViewController}
          />
        )}
        {role?.additional_fees && (
          <DashGuard
            exact
            path="/additional-fees"
            component={AdditionalFeesController}
          />
        )}
        <DashGuard
          exact
          path="/customers/:id"
          component={SubscriberController}
        />
        <DashGuard exact path="/logout" component={Logout} />
      </Switch>
      <AuthVerifyComponent />
    </Router>
  );
}
